import axios from 'axios';
import config from '../config/config';

export async function getAllContactsList() {
  const res = await axios
    .get(config.apiURL + `/contacts`, {
      headers: {
        'Content-Type': 'application/json',
        token: config.getToken()
      }
    })
    .catch((err) => {
      console.log(err.response);
      alert(err.response?.data);
    });
  if (res?.status === 200) {
    return res;
  }
}
